import {
  ITEM_DRAG_TOGGLE,
  ITEM_DRAG_DROP,
  UPDATE_QUERY,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    elementDragging: false,
    data: {},
  };
};

const initialState = getInitialState();

const itemDragDrop = (state = initialState, action) => {
  const types = {
    [ITEM_DRAG_TOGGLE]: () => ({
      ...state,
      elementDragging: action.mode,
    }),
    [ITEM_DRAG_DROP]: () => ({
      ...state,
      elementDragging: false,
    }),
    [UPDATE_QUERY]: () => ({
      ...state,
      elementDragging: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default itemDragDrop;
